import { Box, makeStyles, styled, Typography } from '@material-ui/core';
import { DLRLogo } from '../../theme/DLRLogo';
import { Link } from 'react-router-dom';

export const StyledLogo = styled(DLRLogo)(() => ({
  height: '80px',
  width: '360px',
  color: '#fff',
}));

export const HomeTitle = styled(Typography)(() => ({
  color: '#fff',
  fontSize: '24px',
  fontWeight: 800,
  margin: 0,
}));

export const useSearchBarStyles = makeStyles(() => ({
  searchBarInput: {
    margin: '0',
    backgroundColor: '#fff',
    borderRadius: '100px',
    '&::placeholder': {
      color: '#fff',
    },
  },
  searchBar: {
    margin: '0',
  },
}));

export const HomeColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gridRowGap: '48px',
  flexBasis: '50%',
}));

export const HomeCardsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gridColumnGap: '32px',
}));

export const HomePageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gridRowGap: '24px',
}));

export const HomeCardImageLink = styled(Link)(({ theme }) => ({
  width: '177px',
  height: '135px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '10px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const HomeCardTitle = styled(Typography)(() => ({
  fontWeight: 700,
  color: '#000',
  letterSpacing: '0.32px',
  lineHeight: '37px',
  fontFamily: 'Red Hat Display',
}));

export const HomeCardDescription = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 400,
  letterSpacing: '0.32px',
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '4',
  color: theme.palette.text.secondary,
}));

export const HomeCardContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gridColumnGap: '16px',
}));

export const HomeBannerOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.primary.main,
  opacity: 0.89,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const HomeBannerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '300px',
  padding: '30px 0 30px 70px',
  borderRadius: '10px',
  position: 'relative',
  background: "url('./home_bg.png')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  overflow: 'hidden',
  gap: '50px',
}));

export const HomeBannerImageBox = styled(Box)(() => ({
  left: 0,
  bottom: '-30px',
  height: '100%',
  zIndex: 1,
  position: 'absolute',
  background: `url('./api_bg.jpg') left top no-repeat`,
  borderRadius: '10px 10px 0px 0px',
  backgroundSize: 'cover',
  width: '770px',
}));

export const HomeBannerContentBox = styled(Box)(() => ({
  zIndex: 2,
  minWidth: '556px',
  display: 'flex',
  flexDirection: 'column',
  gridRowGap: '16px',
}));

export const HomeBannerImageWrapper = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
}));

export const HomeCardLinks = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gridRowGap: '8px',
}));

export const HomeCardLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
  '&:hover': {
    textDecoration: 'underline',
  },
}));
